<template>
  <v-menu v-model="menu" transition="slide-y-transition" bottom :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="menu = true" v-on="on" class="mx-3">
            <v-icon>
              {{ settingsIcon }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $vuetify.lang.t('$vuetify.map.managerMap.localFilters.title') }}</span>
      </v-tooltip>
    </template>

    <v-card max-width="500" class="fill-height" height="100%">
      <v-card-title>
        <span class="subtitle-2">{{ $vuetify.lang.t('$vuetify.map.managerMap.localFilters.title') }}</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-0">
        <v-switch v-model="isOnlyNano" class="mb-0"
                  :label="$vuetify.lang.t('$vuetify.map.managerMap.localFilters.filters.isOnlyNano')"></v-switch>
        <datetime-chart-filter class="ml-md-n4"
                               v-if="timeRangeFilter.filter"
                               :is-time-first="true"
                               :start-date="`${timeRangeFilter.filter.date.start.date}`"
                               :finish-date="`${timeRangeFilter.filter.date.finish.date}`"
                               :trim-date="false"
                               :reset="true"
                               :non-card="true"
                               :header="$vuetify.lang.t('$vuetify.map.managerMap.localFilters.filters.timeRangeFilter.title')"
                               :is-active="true" :active-value="timeRangeFilter.isUsed"
                               @active-value-changed="timeRangeFilter.isUsed = $event"
                               @datetime-cleared="clearTimeRangeFilter"
                               @datetime-changed="setSlidesDatetime"></datetime-chart-filter>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn text color="green" @click="$emit('map-table-refresh'); menu = false">
          {{ $vuetify.lang.t('$vuetify.map.managerMap.localFilters.apply') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mdiFilterMenu } from '@mdi/js'
import { createHelpers } from 'vuex-map-fields'
import { SETTINGS_MODULE } from '@/store/modules'
import { getCurrentTime } from '@/utils/time'
import { defaultChartDatetimeState } from '@/utils/filters'
import DatetimeChartFilter from '@/components/charts/utils/datetimeChartFilter'

const { mapFields } = createHelpers({
  getterType: `${SETTINGS_MODULE}/getField`,
  mutationType: `${SETTINGS_MODULE}/updateField`
})

const { _currentYear, _currentMonth, _lastDay } = getCurrentTime()

const getDefaultTimeRangeFilter = () => ({
  start: defaultChartDatetimeState(`${_currentYear}-${_currentMonth}-01`),
  finish: defaultChartDatetimeState(`${_currentYear}-${_currentMonth}-${_lastDay}`)
})

export default {
  name: 'mapManagerLocalFilters',
  components: { DatetimeChartFilter },
  data: () => ({
    menu: false,
    settingsIcon: mdiFilterMenu
  }),
  computed: {
    ...mapFields(['mapLocalFilters.isOnlyNano', 'mapLocalFilters.timeRangeFilter'])
  },
  methods: {
    setSlidesDatetime (datetime) {
      this.timeRangeFilter.filter.date[datetime.type][datetime.mode] = datetime.value
    },
    resetTimeRangeFilter () {
      this.timeRangeFilter.isUsed = false
      this.isOnlyNano = false
      this.clearTimeRangeFilter()
    },
    clearTimeRangeFilter () {
      if (!this.timeRangeFilter.filter) {
        this.timeRangeFilter.filter = {
          date: null
        }
      }

      this.timeRangeFilter.filter.date = getDefaultTimeRangeFilter()
    }
  },
  created () {
    this.resetTimeRangeFilter()
  }
}
</script>

<style scoped>

</style>
